module.exports = __webpack_public_path__ + "img/NFishingBoat64_ua.3a0a3faf.webp";